/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 15:08:10
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-20 10:23:36
 */
import Vue from "vue";
import sysContent from "../components/sys-content/sys-content.vue";
import tabsContent from "../components/tabs-content/tabs-content.vue";
import listPage from "../components/list-page/list-page.vue";
import searchContent from "../components/search-content/search-content.vue";
import piBlockContent from "../components/pi-block-content/pi-block-content.vue";
import flexScroll from "../components/flex-scroll/flex-scroll.vue";
import flexScrollBox from "../components/flex-scroll/flex-scroll-box.vue";
import piCard from "../components/pi-card/pi-card.vue";
import piCardBox from "../components/pi-card-box/pi-card-box.vue";
import piButton from "../components/pi-button/pi-button.vue";
import piButtonSelect from "../components/pi-button-select/pi-button-select.vue";
import piTag from "../components/pi-tag/pi-tag.vue";
Vue.component("pi-sys-content", sysContent);
Vue.component("tabs-content", tabsContent);
Vue.component("pi-list-page", listPage);
Vue.component("pi-search-content", searchContent);
Vue.component("pi-block-content", piBlockContent);
Vue.component("pi-flex-scroll", flexScroll);
Vue.component("pi-flex-scroll-box", flexScrollBox);
Vue.component("pi-card", piCard);
Vue.component("pi-card-box", piCardBox);
Vue.component("pi-button", piButton);
Vue.component("pi-button-select", piButtonSelect);
Vue.component("pi-tag", piTag);
